import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutService } from '../service/layout.service';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { environment } from '../../../environments/environment';

@Component({
    selector: '[app-footer]',
    standalone: true,
    imports: [CommonModule, RouterModule, ButtonModule, ToolbarModule],
    template: ` <div class="layout-footer">
        <img style="height: 2rem; width: 2rem;" [src]="'../../../images/eflogotransparent-' + (layoutService.isDarkTheme() ? 'avalon-dark' : 'avalon') + '.png'" alt="avalon-footer-logo" />
        <div *ngIf="environment.production == false">
            TEST Environment: {{ environment.environment }}
        </div>
        <div class="flex gap-2">
            <button pButton pRipple type="button" icon="pi pi-youtube" pTooltip="eFAACT Youtube" rounded text plain (click)="openLink('https://www.youtube.com/@efaact')"></button>
            <button pButton pRipple type="button" icon="pi pi-apple" pTooltip="eF Mobile on Apple" rounded text plain (click)="openLink('https://itunes.apple.com/us/app/efaact-mobile/id1339793265?mt=8')"></button>
            <button pButton pRipple type="button" icon="pi pi-android" pTooltip="eF Mobile on Android" rounded text plain (click)="openLink('https://play.google.com/store/apps/details?id=eFAACT_TimeCard.Droid&hl=en')"></button>
        </div>
    </div>`
})
export class AppFooter {
    layoutService: LayoutService = inject(LayoutService);
    environment = environment;
    openLink(url: string): void {
        window.open(url, '_blank');
    }
}
